module.exports = __webpack_public_path__ + "img/switzerland-liver-cancer-male.afaf4d90.png";